<template>
    <div id="footer" class="footer">
        <div class="footer-main">
            <!-- <div class="address-line" v-show="$route.path=='/home'">
                <span>北京总部：北京市海淀区紫竹院路116号嘉豪国际中心B座8层</span>
                <span>上海办事处：上海市普陀区金沙江路1518弄近铁广场北座1018室</span>
            </div> -->
            <div class="friends-link">
                <span>友情链接：</span>
                <a href="http://www.gongkong.com/" target="_blank">中国工控网</a>
                <a href="http://www.gongkongmall.com/" target="_blank">工控猫</a>
                <a href="http://www.gongkongedu.com/" target="_blank">工控教育</a>
                <a href="http://www.gongkong.com/hr/index.html" target="_blank">工控人才</a>
                <a href="http://video.gongkong.com/" target="_blank">工控网视频</a>
                <a href="http://www.shuigongye.com/" target="_blank">中国水工业网</a>
                <a href="http://www.chinaopc.org/" target="_blank">OPC中国</a>
                <a href="http://www.gkquan.com/" target="_blank">工控圈</a>
                <a href="http://www.casicloud.com" target="_blank">航天云网</a>
                <a href="http://www.gepresearch.com" target="_blank">环保研究网</a>
                <a href="http://www.insupai.com/Help/helpCenter_19.html">更多</a>
            </div>
            <div class="sp-copyright">
                <span>版权所有：Copyright&nbsp;<i>©</i>&nbsp;insupai.com</span>
                <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><span style="color: #999;font-size: 14px;display: inline-block;vertical-align: top;height: 26px;margin-right: 10px;line-height: 26px;">京ICP备16043380号-4</span></a>
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802040674" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><span style="color: #999;font-size: 14px;display: inline-block;vertical-align: top;height: 26px;margin-right: 10px;line-height: 26px;"><img style="margin-top: 3px;" src="../assets/home/gongan.png"/> 京公网安备: 11010802040674号</span></a>
                <span>电信业务审批【2014】字第180号</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    }
}
</script>
<style lang="scss">

#footer {
    padding: 20px 0;
    footer-main {
        width: 1200px;
        margin: 0 auto;
    }
    .address-line{
        text-align: center;
        color: #999;
        font-size: 14px;
        line-height: 24px;
        span{
            padding:0 10px;
        }
    }
    .friends-link {
        height: 26px;
        line-height: 26px;
        text-align: center;
        a,span{
            display: inline-block;
            vertical-align: top;
            color: #999;
            font-size: 14px;
            display: inline-block;
            margin-right: 10px;
            line-height: 24px;
        }
        a:hover {
            color: #f75959;
        }
    }
    .sp-copyright {
        text-align: center;
        line-height: 26px;
        color: #999;
        height: 26px;
        line-height: 24px;
        &>* {
            font-size: 14px;
            display: inline-block;
            vertical-align: top;
            height: 26px;
            margin-right: 10px;
        }
    }
}
</style>